import { PolygonType } from 'src/app/bo/polygon/tirsPolygone';
import { TirsPolygoneEnum } from 'src/app/bo/polygon/tirPolygoneEnum';
import { ALL_POLYGON_TYPES, DEFAULT_POLYGON_TYPES } from '../site-map.constants';

export const PREFERENCE_KEYS = {
  orthophotos: 'isOrthoLayerVisible',
  satellite: 'isBingLayerVisible',
  controlPoints: 'controlPointsToggle',
  zonesOfInterest: 'zoiToggle',
  polygonTypes: 'cartSelectedTirsPolygoneEnum',
} as const;

const POLYGON_ENUM_BY_TYPE: Record<PolygonType, TirsPolygoneEnum> = {
  [PolygonType.AutomaticFromHoles]: TirsPolygoneEnum.AUTOMATIC,
  [PolygonType.DrillingContour]: TirsPolygoneEnum.DRILLED,
  [PolygonType.MuckPile]: TirsPolygoneEnum.MUCKPILE,
  [PolygonType.DangerZone]: TirsPolygoneEnum.DANGER_ZONE,
};

/** Lit un booléen du localStorage. Les clés sont celles de l'ancienne carte : les préférences suivent l'utilisateur d'un front à l'autre. */
export function loadBooleanPreference(key: string, fallback: boolean): boolean {
  try {
    const raw = localStorage.getItem(key);
    return raw === null ? fallback : JSON.parse(raw) === true;
  } catch {
    return fallback;
  }
}

export function saveBooleanPreference(key: string, value: boolean): void {
  try {
    localStorage.setItem(key, JSON.stringify(value));
  } catch {}
}

/** Types de polygones affichés, stockés au format de l'ancienne carte (valeurs de TirsPolygoneEnum). */
export function loadPolygonTypesPreference(): PolygonType[] {
  try {
    const raw = localStorage.getItem(PREFERENCE_KEYS.polygonTypes);
    if (raw) {
      const saved: unknown = JSON.parse(raw);
      if (Array.isArray(saved)) {
        return ALL_POLYGON_TYPES.filter(type => saved.includes(POLYGON_ENUM_BY_TYPE[type]));
      }
    }
  } catch {}
  return [...DEFAULT_POLYGON_TYPES];
}

export function savePolygonTypesPreference(types: PolygonType[]): void {
  try {
    localStorage.setItem(PREFERENCE_KEYS.polygonTypes, JSON.stringify(types.map(type => POLYGON_ENUM_BY_TYPE[type])));
  } catch {}
}
